import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/autovit-alternativa/")({
  head: () => routeHead("/autovit-alternativa/"),
  beforeLoad: () => {
    throw redirect({ href: "/ghiduri/platforme-auto-romania-cum-alegi", statusCode: 301, replace: true });
  },
});
